import React, { useState, useEffect, useCallback } from "react";

import { useForm } from "react-hook-form";
import { Button } from "../../../Components/Basic";

import { customClasses } from "../../../Styles/customClasses";

import firebase from "firebase";
import "firebase/functions";

function QualifyResults({ onSubmit, store }) {
  const [jurisdiction, setJurisdiction] = useState(false);

  const db = firebase.firestore();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
  });

  useEffect(() => {
    if (
      store?.aust_citizen_requirement === "Yes" ||
      store?.aust_live_indefinitely_requirement === "Yes" ||
      store?.aust_live_12m_requirement === "Yes"
    ) {
      setJurisdiction(true);
      saveToFirebase({ residencyRequirement: true });
    } else {
      saveToFirebase({ residencyRequirement: false });
    }
  }, []);

  const saveToFirebase = async ({ residencyRequirement }) => {
    if (
      store?.separated_12m === "No" ||
      store?.marriage_over === "No" ||
      residencyRequirement === false
    ) {
      try {
        await db
          .collection("cantDivorceList")
          .doc(store?.user_email)
          .set(store);
      } catch (error) {
        alert(
          "An error occurred. Please contact us to discuss what happened. Error1.1"
        );
      }
    } else {
      try {
        await db
          .collection("divorceAssessment")
          .doc(store?.user_email)
          .set(store);
      } catch (error) {
        alert(
          "An error occurred. Please contact us to discuss what happened. Error2.2"
        );
      }
    }
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className="mx-auto w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/2  p-10 mt-10 mb-10 shadow-lg">
        {store?.separated_12m === "No" ||
        store?.marriage_over === "No" ||
        jurisdiction === false ? (
          <section>
            <div className="bg-red-500 rounded min-h-36 relative	">
              <p className="text-black text-center text-white text-3xl pt-5 px-5">
                You Can’t Get Divorced Yet
              </p>
              <p className="text-black mt-2 pb-5 text-white	text-center px-5">
                You don’t meet the criteria under Australian law to get
                divorced.
              </p>
            </div>
            <div className="mt-10">
              <p> To get divorced you need:</p>
              <ul className="mt-5 list-disc space-y-2 pl-10">
                <li>To be separated for 12 months.</li>
                <li>
                  Your relationship has to be over (e.g no reasonable chance of
                  getting back together).
                </li>
                <li>There needs to be a connection to Australia.</li>
              </ul>
            </div>

            <div className="mt-10">
              <p>
                A connection to Australia can be established if either you or
                your spouse:
              </p>
              <ul className="mt-5 list-disc space-y-2 pl-10">
                <li>
                  Regard Australia as your home and intend to live in Australia
                  indefinitely;
                </li>
                <li>Are an Australian citizen; or</li>
                <li>
                  Ordinarily live in Australia and have done so for 12 months
                  immediately before filing for divorce.
                </li>
              </ul>
            </div>
            <div className="flex justify-center">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "https://www.familylawassist.com.au/";
                }}
                fontSize="lg"
                form="divorce-form"
                className="mt-10 w-full md:max-w-xs mx-3 md:mx-0 focus:outline-none p-4 bg-nativeOrange-200 hover:bg-yellow-500  hover:border-yellow-500"
              >
                Learn About Other Options
              </Button>
            </div>
          </section>
        ) : (
          <section>
            <div className="flex flex-col items-center ">
              {/* checkbox SVG heroicons*/}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-16 w-16 text-green-500 flex-1 mb-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              <div className="bg-green-500 h-28 rounded flex px-10 flex-col justify-center">
                <p className=" text-3xl text-center  text-white">
                  You’re Able To Get Divorced In Australia
                </p>
              </div>

              <div className="mt-10">
                {/* <p className="mb-5">
                  You meet the criteria under Australian law to get divorced.
                </p> */}
                <p>
                  We’ll need to ask a few quick details to give you an idea of
                  how much it will cost.
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <Button
                type="submit"
                fontSize="lg"
                form="divorce-form"
                className="mt-10 w-full md:max-w-xs mx-3 md:mx-0 focus:outline-none p-4 bg-nativeBlue-200 hover:bg-nativeBlue-300  hover:border-nativeBlue-300"
              >
                Find Out The Cost
              </Button>
            </div>
          </section>
        )}
      </section>
    </form>
  );
}

export default QualifyResults;
